import { useNavigate } from "react-router-dom";
import logo from "../../assets/error_404.jpg";
import "../css/error404.css";

const PaginaNoEncontrada = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className="ErrorPaginaNoEncontrada">
      <div className="error-content">
        <img alt="Página no encontrada" src={logo} />
        <div className="error-text">
          <h1>¡Oops!</h1>
          <p>La página que buscas no existe.</p>
          <p className="error-description">
            Es posible que la URL esté mal escrita o que la página haya sido movida.
          </p>
        </div>
        <div className="error-actions">
          <button onClick={handleGoBack} className="btn btn-secondary">
            ← Volver atrás
          </button>
          <button onClick={handleGoHome} className="btn btn-primary">
            🏠 Ir al inicio
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaginaNoEncontrada;